// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__I3P3y","inputWrap":"Table_inputWrap__3IpKo","col":"Table_col__rprve","bmiTooltip":"Table_bmiTooltip__3tH4W"};